import { EndingSoon } from "../Landing/EndingSoon"
import { HomepageHero } from "../Landing/HomepageHero"
import { NeedCashBanner } from "../Landing/NeedCashBanner"
import { RecentlySold } from "../Landing/RecentlySold"
import { ShopCategory } from "../Landing/ShopCategory"
import { ShopPopularBrands } from "../Landing/ShopPopularBrands.jsx"
import { TurnUnusedGunsIntoCash } from "../Landing/TurnUnusedGunsIntoCash"
import { WhoYoureBuyingFrom } from "../Landing/WhoYoureBuyingFrom"

export const LandingFirearmsContainer = () => (
    <div className="relative overflow-x-hidden overflow-y-hidden">
        <HomepageHero />
        <EndingSoon />
        <ShopCategory />
        <ShopPopularBrands />
        <RecentlySold />
        <NeedCashBanner />
        <WhoYoureBuyingFrom />
        <TurnUnusedGunsIntoCash />
    </div>
)
